<router-outlet>
  <div id="initial_loader">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</router-outlet>
<ui-notifier></ui-notifier>
